<!-- eslint-disable max-len -->
<template>
  <svg
    width="39"
    height="17"
    viewBox="0 0 39 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.535206 14.6981C0.314293 15.259 0.589895 15.8928 1.15078 16.1137C1.71167 16.3346 2.34544 16.059 2.56636 15.4981L0.535206 14.6981ZM33.9675 16.139C34.5423 16.3205 35.1555 16.0015 35.3369 15.4267L38.2941 6.05876C38.4756 5.4839 38.1567 4.87078 37.5818 4.68931C37.0069 4.50784 36.3938 4.82675 36.2123 5.40162L33.5837 13.7287L25.2567 11.1001C24.6818 10.9186 24.0687 11.2375 23.8873 11.8124C23.7058 12.3872 24.0247 13.0004 24.5996 13.1818L33.9675 16.139ZM2.56636 15.4981C5.23541 8.72155 10.479 3.9454 16.1268 3.19573C21.6625 2.46095 28.098 5.54729 33.3277 15.6018L35.2644 14.5944C29.7889 4.06751 22.6174 0.132035 15.8396 1.0317C9.17387 1.91648 3.39745 7.43104 0.535206 14.6981L2.56636 15.4981Z"
      fill="currentColor"
    />
  </svg>
</template>
  
